import store from "../../redux/store";
import authSlice from "../../redux/slice/authSlice";
import { axiosUnauth } from "./axios";

export const authActions = authSlice.actions;

// Add this outside the function to track ongoing refresh
let refreshPromise = null;

const getNewAuthToken = async () => {
    // If there's already a refresh in progress, return that promise
    if (refreshPromise) {
        return refreshPromise;
    }

    const dispatch = store.dispatch;
    try {
        // Create new promise and store it
        refreshPromise = (async () => {
            const res = await axiosUnauth.post(
                "/api-users/refresh-token/",
                {},
                { withCredentials: true }
            );
            

            if (res.data?.error) {
                throw new Error("invalid_grant");
            }

            const { access_token } = res.data.data;
            dispatch(
                authActions.loadToken({
                    access_token,
                })
            );

            return {
                access_token,
            };
        })();

        const result = await refreshPromise;
        return result;
    } catch (err) {
        // console.error("Failed to get new auth token:", err);
        throw err;
    } finally {
        // Clear the promise so future calls can try again
        refreshPromise = null;
    }
};

/* eslint import/no-anonymous-default-export: [2, {"allowNew": true}] */
export default getNewAuthToken;
